import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Card, Tab } from "@mui/material";
import React from "react";
import UserAccounts from "./Components/UserAccounts/UserAccounts";
import UserLoans from "./Components/UserLoan/UserLoans";
import UserProfileInfo from "./Components/UserProfileInfo";
import LoanRequests from "../Loans/LoanRequests";
import GuarantorNominations from "./Components/Guarantors/GuarantorNominations";
import Shares from "../Shares/Shares";
import Guarantors from "./Components/Guarantors/Guarantors";
import MemberShares from "../Shares/MemberShares";
import UserTransactions from "./Components/userTransactions";
import { getUserDetails } from "../../utils/helpers";
import Deposits from "../Transactions/Deposits";
import UserSavings from "../Transactions/UserSavings";
import UserPoolTransactions from "../PoolFund/UserPoolTransactions";
import KinInfo from "./Components/UserKin/KinInfo";
import Messages from "./Components/UserSms/Messages";
import { useSelector } from "react-redux";
import GuarantorshipWallet from "./Components/Guarantors/GuarantorshipWallet";
import UserOutstandingDisbursements from "./Components/UserOutstandingDisbursements";

const UserTabs = ({ user, fetchUser }) => {
  const loggedInuser = useSelector((state) => state.auth.user);
  const [value, setValue] = React.useState("14");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      {/* <CardContent> */}
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="user tabs"
            allowScrollButtonsMobile
            variant="scrollable"
            textColor="secondary.lighter"
            indicatorColor="secondary"
            scrollButtons="auto"
            sx={{
              // width: "100%",
              borderRadius: "8px",
              // background: "linear-gradient(60deg, #decce1ff, #8e24aa)",
              background: "#eeeeeef",
              // padding: "10px",
              // boxShadow: "0px 3px 15px rgba(34, 35, 58, 0.5)",
              // [`& .${tabsClasses.indicator}`]: {
              //   // color: "#fff",
              //   height: "100%",
              //   borderRadius: "8px",
              //   backgroundColor: "rgba(248, 30, 238, 0.55)",
              // },
            }}
          >
            {loggedInuser?.role === "admin" && (
              <Tab label="Accounts" value="2" />
            )}
            <Tab label="Profile Info" value="14" />
            <Tab label="Deposits" value="11" />
            <Tab label="Wallet" value="10" />
            <Tab label="Savings" value="12" />
            <Tab label="Guarantorship Wallet" value="16" />
            <Tab label="Messages" value="15" />
            <Tab label="Pool" value="13" />
            <Tab label="Loan" value="3" />
            <Tab label="Loan Requests" value="4" />
            <Tab label="Guarantees" value="5" />
            <Tab label="Guarantors" value="7" />
            <Tab label="Shares" value="6" />
            <Tab label="Outstanding Disbursements" value="17" />
            {/* <Tab label="Next of Kin" value="1" /> */}

            {/* <Tab label="Transactions" value="8" /> */}
            {/* <Tab label="Bid Shares" value="9" /> */}
          </TabList>
        </Box>

        <TabPanel value="14">
          <UserProfileInfo />
        </TabPanel>

        <TabPanel value="1">
          <KinInfo user={user} />
        </TabPanel>

        <TabPanel value="2">
          <UserAccounts showHeader={false} />
        </TabPanel>

        <TabPanel value="3">
          <UserLoans fetchUser={fetchUser} showHeader={false} />
        </TabPanel>
        <TabPanel value="4">
          <LoanRequests user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="5">
          <GuarantorNominations user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="6">
          <MemberShares user={user} fetchUser={fetchUser} />
        </TabPanel>
        <TabPanel value="7">
          <Guarantors user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="8">
          <UserTransactions user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="9">
          <Shares user={user} fetchUser={fetchUser} />
        </TabPanel>
        <TabPanel value="10">
          <UserTransactions user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="11">
          <Deposits user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="12">
          <UserSavings user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="13">
          <UserPoolTransactions user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="15">
          <Messages user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="16">
          <GuarantorshipWallet user={user} showHeader={false} />
        </TabPanel>
        <TabPanel value="17">
          <UserOutstandingDisbursements _user={user} showHeader={false} />
        </TabPanel>
      </TabContext>
      {/* </CardContent> */}
    </Card>
  );
};

export default UserTabs;
